// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalAdminsPage_container__o-C3X","cardContainer":"GlobalAdminsPage_cardContainer__2mDAw"};